import React from 'react';

import {LicenseeType} from "../../../../schema";
import {OfficeBuildingIcon, UserIcon} from "@heroicons/react/outline";

type Props = {
  type: LicenseeType
  className?: string
}

export default function LicenseeTypeStatus({ type, className }: Props) {

  if (type === LicenseeType.Company) {
    return (
      <div className={className}>
        <OfficeBuildingIcon className="text-gray-dark w-4 h-4 inline"/> Company
      </div>
    );
  } else {
    return (
      <div className={className}>
        <UserIcon className="text-gray-dark w-4 h-4 inline"/> Trainer
      </div>
    );
  }
}
